import app from 'flarum/forum/app';
import LanguageDisplay from '../components/LanguageDisplay';

/**
 * The forum's languages, by code, with `any` among them when it is offered.
 */
export default function generateLanguageOptions() {
  const options = {};
  app.store.all('discussion-languages').forEach(language => {
    options[language.code()] = m(LanguageDisplay, {
      language: language
    });
  });
  return options;
}
flarum.reg.add('fof-discussion-language', 'forum/utils/generateLanguageOptions', generateLanguageOptions);